<template>
  <div class="h-full overflow-hidden flex flex-col pt-3">
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref="tableDom"
    >
      <el-table-column
        fixed
        label="#"
        width="70"
        type="index"
        :index="
          (index) =>
            $buildTabIndex(state.params.page, state.params.limit, index)
        "
        align="center"
      />
      <el-table-column>
        <template #header>
          <div class="c-table-col-header" label1="状态" label2="审批人" />
        </template>
        <template #default="{ row }">
          <c_tabgroup>
            <template #top>
              <c_status
                arrName="Office_Expense_Apply_Status"
                :value="row.status"
              />
            </template>
            <template #bottom>
              <ul class="flex gap-x-2">
                <text class="text-gray-600">
                  {{ row?.flowApproveStep?.approve_admin_name }}
                </text>
                <text>{{ row?.flowApproveStep?.approve_department_name }}</text>
              </ul>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column :width="300">
        <template #header>
          <div
            class="c-table-col-header"
            label1="费用名称"
            label2="申请单/申请人"
          />
        </template>
        <template #default="{ row }">
          <c_tabgroup
            :value2="row.meeting?.start_date + ' ~ ' + row.meeting?.end_date"
          >
            <template #top>
              <div
                class="flex items-center text-green-700 cursor-pointer hover:underline"
              >
                <strong>{{ row.name }}</strong>
                <text class="text-xs">
                  {{ "[" + row.number + "]" }}
                </text>
              </div>
            </template>
            <template #bottom>
              <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
                <text class="text-sm text-gray-600">
                  {{ row?.add_admin_name }}
                </text>
                <text>{{ row?.add_department_name }}</text>
                <text class="ml-1">{{ row?.create_time }} 创建</text>
              </div>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column label="类型" prop="type_name">
        <template #default="{ row }">
          <text>{{
            row.d_office_expense_type_pname + " - " + row.d_office_expense_type_name
          }}</text>
        </template>
      </el-table-column>
      <el-table-column
        label="合计金额"
        prop="amount"
        :formatter="$tab_MoneyFormat"
      />
      <el-table-column label="支付渠道" prop="type_name">
        <template #default="{ row }">
          <c_status
            arrName="Office_Expense_Apply_Payment_Method"
            :value="row.payment_method"
            :key="row.payment_method"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="intro"
        label="申请说明"
        :formatter="$tab_TextFormat"
        :min-width="160"
      />
      <el-table-column label="操作" fixed="right" align="center" :width="260">
        <template #default="{ row }">
          <el-button
            type="primary"
            :icon="Money"
            link
            v-if="row.status === 1"
            @click.stop="
              state.selectId = row.id;
              state.showDetail = true;
            "
            >付款
          </el-button>
          <el-button
            type="success"
            :icon="Search"
            link
            @click.stop="
              state.selectId = row.id;
              state.showDetail = true;
            "
            v-else
            >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      :pageSize="state.params.limit"
      @onLoad="
        (page) => {
          state.params.page = page.pageIndex;
          state.params.limit = page.pageSize;
          onLoad();
        }
      "
    />
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="采购付款"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 70%"
    append-to="#home_box"
  >
    <c_detail
      :id="state.selectId"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { officeExpensePay_page } from "@/http/fukuancaozuo";

import c_detail from "./FeiYongFuKuanDetail";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_detail,
  },
  props: {
    params: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
      check: {
        files: [],
      },
    });
    onMounted(() => {
      state.params.status = props.params?.status;
      state.params.keywords = props.params?.keywords;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      officeExpensePay_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return { state, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
